<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="container">
      <div class="row page-section">
        <div class="col-md-4 col-xs-6 text-center">
          <form class="prepaid-form" @submit.prevent="proceedToRecharge">
            <img
              :src="getOperatorLogo"
              alt="Operator"
              class="recharge-info-card__operator-image"
              v-if="getOperatorLogo"
            />
            <p class="title">
              Bill Payment of {{ selectedServiceProvider }}
              <!-- <br />
              {{ billResponse.transactionInfo.requestId }}-->
            </p>
            <p class="mt-30 sub-title">Amount</p>
            <p>
              <b class="amount">{{ selectedPlan | formatCurrency }}</b>
            </p>
            <p class="text-red text-center">{{ pageError }}</p>
            <ActionButton title="Pay Now" />
          </form>
        </div>
        <div class="col-md-8 col-xs-6" id="navigate-section">
          <div class="prepaid-form pull-right">
            <div class="back-section" @click="navigateBack">
              <img src="/static/images/pngs/arrow-left.png" />Back
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
export default {
  name: "ChoosePlanPostpaidWeb",
  props: ["category", "billResponse", "queryData"],
  data() {
    return {
      pageError: "",
      query: {},
    };
  },
  computed: {
    ...mapGetters([
      "loggedIn",
      "operators",
      "selectedPlan",
      "selectedServiceProvider",
      "selectedBillFetch",
    ]),
    getOperatorLogo() {
      const el = this.operators.find((e) => e.operator === this.operator);
      if (el) {
        return el.logo;
      }
    },
  },
  components: { ActionButton },
  methods: {
    proceedToRecharge() {
      this.query = this.queryData;
      this.query.transactionInfo.description = this.selectedServiceProvider;
      this.query.transactionInfo.amount = this.selectedPlan;
      delete this.query.name;
      if (this.billResponse) {
        this.query.transactionInfo.requestId = this.billResponse.transactionInfo.requestId;
      }
      if (this.selectedBillFetch) {
        delete this.query.transactionInfo.questions;
      }
      if (this.selectedPlan) {
        this.pageError = "";
        this.$store
          .dispatch("createTxn", {
            params: this.query,
          })
          .then((response) => {
            // console.log(response);
            if (response.responseInfo.responseCode + "" == "0") {
              this.$router.push({
                name: "EplNewPaymentSuccess",
                params: {
                  category: this.category,
                  type: this.routeType,
                  transactionInfo: response.transactionInfo,
                },
              });
            } else if (
              response.responseInfo.responseCode + "" == "01" ||
              response.responseInfo.responseCode + "" == "-1"
            ) {
              this.$router.push({
                name: "EplNewPaymentFailure",
                params: {
                  category: this.category,
                  type: this.routeType,
                  responseMessage: response.responseInfo,
                },
              });
            } else {
              this.$router.push({
                name: "EplNewPaymentPending",
                params: {
                  category: this.category,
                  type: this.routeType,
                  responseMessage: {
                    responseDescription:
                      'Your order is taking longer than expected. We will notify you if the transaction is successful. You can also check "Bill payments and Recharge History" for latest status.',
                  },
                },
              });
            }
          })
          .catch((err) => {
            this.$router.push({
              name: "EplNewPaymentFailure",
              params: {
                category: this.category,
                type: this.routeType,
                responseMessage: {
                  responseDescription:
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                      ? err.response.data.message
                      : "Failed due to unknown reason",
                },
              },
            });
          });
      }
    },
    navigateBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.title {
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 1px;
  color: #4d4d4d;
}
.sub-title {
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.88px;
  color: #4d4d4d;
}
.amount {
  font-size: 20px;
  line-height: 31px;
  letter-spacing: 1.25px;
  color: #4d4d4d;
}
.mt-30 {
  margin-top: 30px;
}
.mb-0 {
  margin-bottom: 0px;
}

.recharge-info-card {
  display: flex;
  padding: 18px;
  align-items: center;
  border-radius: 4px;
  // border: solid 0.2px #979797;
  background-color: #ffffff;
  &__operator-image {
    height: 53px;
  }
  &__text {
    margin-left: 1rem;
    &__number,
    &__subtitle {
      display: block;
    }
    &__number {
      font-size: 15px;
      font-weight: 500;
      letter-spacing: 1px;
      color: #4d4d4d;
      margin-bottom: 5px;
    }
    &__subtitle {
      font-size: 14px;
      color: #979797;
      margin-bottom: 0;
    }
  }
  &__service-provider-image {
    height: 20px;
    margin-left: auto;
  }
}
#navigate-section {
  position: relative;
  min-height: 275px;
}
.back-section {
  position: absolute;
  bottom: 0;
  color: #979797;
  cursor: pointer;
  right: 40px;
}
.bbps-logo {
  width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/BillWeb.vue